import { DeviceModelName } from './DeviceModelName';

export default DeviceModelName;
